import {IDictionary} from '@/shared/models/interface/dictionary-model';
import {LocalStorageService} from '../services/local-storage-service';
import {ResultsService} from '../services/results-service';
import {IConfig} from './config';
import {IQuestion} from './question';
import {IResult} from './result';

export interface IState {
    config: IConfig,
    loading: boolean,
    currentComponent: string,
    explanationActive: boolean,
    currentIndex: number,
    questions: IQuestion[],
    answers: IDictionary<boolean>,
    results: IDictionary<IResult[]>,
    localStorageService: LocalStorageService,
    resultsService: ResultsService
}

export class State implements IState {
    config: IConfig = {
        model: {},
        questions: [],
        labels: {},
    };
    currentComponent: string = "";
    explanationActive: boolean = false;
    // QuestionState
    loading: boolean = true;
    currentIndex: number = 0;
    questions: IQuestion[] = [];
    answers: IDictionary<boolean> = {};
    results: IDictionary<IResult[]> = {};
    localStorageService: LocalStorageService = new LocalStorageService();
    resultsService: ResultsService = new ResultsService();
}
